import { UserProfileRole } from '@@types/api.types';
import { Badge } from '@components/ui/badge';
import { BrainIcon, CpuIcon, GraduationCapIcon, ShieldUserIcon } from 'lucide-react';

const roleVariants = {
  [UserProfileRole.ADMIN]: 'admin',
  [UserProfileRole.EXPERT]: 'expert',
  [UserProfileRole.INNOVATOR]: 'innovator',
  [UserProfileRole.INTELLIGENCE]: 'intelligence',
} as const satisfies Record<UserProfileRole, 'admin' | 'expert' | 'innovator' | 'intelligence'>;

const roleLabels = {
  [UserProfileRole.ADMIN]: 'Admin',
  [UserProfileRole.EXPERT]: 'Expert',
  [UserProfileRole.INNOVATOR]: 'Innovator',
  [UserProfileRole.INTELLIGENCE]: 'Intelligence',
} satisfies Record<UserProfileRole, string>;

const roleIcons = {
  [UserProfileRole.ADMIN]: <ShieldUserIcon className="size-4" />,
  [UserProfileRole.EXPERT]: <GraduationCapIcon className="size-4" />,
  [UserProfileRole.INNOVATOR]: <CpuIcon className="size-4" />,
  [UserProfileRole.INTELLIGENCE]: <BrainIcon className="size-4" />,
} satisfies Record<UserProfileRole, React.ReactNode>;

type UserRoleBadgeProps = {
  role: UserProfileRole;
  showIcon?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
};

export const UserRoleBadge: React.FC<UserRoleBadgeProps> = (props) => {
  const { role, showIcon = true, size = 'sm' } = props;

  const variant = roleVariants[role];
  const label = roleLabels[role];
  const icon = roleIcons[role];

  return (
    <Badge
      variant={variant}
      size={size}
    >
      {showIcon && icon}
      {label}
    </Badge>
  );
};
